/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get("slide-show")) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const slideshow = this;
      let slideshow_slides = Array.from(slideshow.querySelectorAll(".carousel__slide")),
        autoplay =
          slideshow.dataset.autoplay == "false"
            ? false
            : parseInt(slideshow.dataset.autoplay, 10),
        align = slideshow.dataset.align == "center" ? "center" : "left",
        fade = slideshow.dataset.fade == "true" ? true : false,
        draggable = slideshow.dataset.draggable == "false" ? false : true,
        pageDots = slideshow.dataset.dots == "true" ? true : false,
        wrapAround = slideshow.dataset.wrapAround == "false",
        groupCells = slideshow.dataset.groupCells == "true",
        header = document.querySelector("theme-header"),
        custom_dots = slideshow.querySelector(".flickity-dots"),
        autoplay_progress = slideshow.querySelector(".slideshow--autoplay-progress"),
        progress_bar = slideshow.parentNode.querySelector(
          ".flickity-progress--bar:not(.slideshow--autoplay-progress)"
        ),
        animations = [],
        rightToLeft = document.dir === "rtl",
        animations_enabled =
          document.body.classList.contains("animations-true") &&
          typeof gsap !== "undefined",
        selectedIndex = 0,
        args = {
          wrapAround: true,
          cellAlign: align,
          pageDots: pageDots,
          contain: true,
          fade: fade,
          autoPlay: autoplay,
          rightToLeft: rightToLeft,
          prevNextButtons: false,
          cellSelector: ".carousel__slide",
          draggable,
          on: {},
        };
      this.paused = false;
      if (custom_dots) {
        args.pageDots = false;
        args.pauseAutoPlayOnHover = false;
      }

      if (wrapAround) {
        args.wrapAround = false;
      }
      if (groupCells) {
        args.groupCells = true;
      }

      if (slideshow.dataset.adapt == "true") {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains("customer-reviews--carousel")) {
        args.wrapAround = true;
        args.resize = true;
      }

      args.wrapAround = false;
      args.on.ready = function () {
        slideshow.setArrowsState(this);
      };

      args.on.change = function () {
        slideshow.setArrowsState(this);
      };
      // Main Slideshow
      if (slideshow.classList.contains("main-slideshow")) {
        args.wrapAround = true;
        if (animations_enabled) {
          slideshow.prepareAnimations(slideshow, animations);
        }

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;

            // Transparent Header padding.
            if (header?.classList.contains("transparent--true")) {
              let i = slideshow.dataset.sectionIndex;

              if (Shopify.designMode) {
                let children = [
                  ...slideshow.closest(".shopify-section").parentNode.children,
                ];
                i = children.indexOf(slideshow.closest(".shopify-section")) + 1;
              }
              if (
                i == 1 &&
                slideshow.classList.contains("section-spacing--disable-top")
              ) {
                slideshow.classList.add("slideshow--top");
              }

              if (i == 1 && slideshow.classList.contains("change-header--true")) {
                let color_text = getComputedStyle(this.selectedElement).getPropertyValue(
                  "--color-text"
                );

                header.style.setProperty("--color-header-transparent-text", color_text);
              }
            }
            // Animations.
            if (animations_enabled) {
              slideshow.animateSlides(0, slideshow, animations);
            }

            // Fonts resize
            document.fonts.ready.then(function () {
              flkty.resize();
            });

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector(
              ".slideshow__slide-video-bg"
            );
            if (video_container) {
              if (video_container.querySelector("iframe")) {
                video_container.querySelector("iframe").onload = function () {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector("video")) {
                video_container.querySelector("video").onloadstart = function () {
                  slideshow.videoPlay(video_container);
                };
              }
            }

            // Custom Dots.
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll("li");
              dots.forEach((dot, i) => {
                dot.addEventListener("click", (e) => {
                  flkty.select(i);
                });
              });

              dots[this.selectedIndex].classList.add("is-selected");
            }
          },
          change: function (index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(
                flkty.selectedIndex - 1,
                flkty.slides.length
              );

            // Animations.
            if (animations_enabled) {
              slideshow.animateReverse(previousIndex, slideshow, animations);
              slideshow.animateSlides(index, slideshow, animations);
            }

            // Color changes.
            let color_text = getComputedStyle(this.selectedElement).getPropertyValue(
                "--color-text"
              ),
              color_text_rgb = getComputedStyle(this.selectedElement).getPropertyValue(
                "--color-text-rgb"
              );

            if (animations_enabled) {
              slideshow.style.setProperty("--color-text", color_text);
              slideshow.style.setProperty("--color-text-rgb", color_text_rgb);
            }
            // Transparent Header padding.
            if (header.classList.contains("transparent--true")) {
              let i = slideshow.dataset.sectionIndex;
              if (Shopify.designMode) {
                let children = [
                  ...slideshow.closest(".shopify-section").parentNode.children,
                ];
                i = children.indexOf(slideshow.closest(".shopify-section")) + 1;
              }
              if (i == 1 && slideshow.classList.contains("change-header--true")) {
                header.style.setProperty("--color-header-transparent-text", color_text);
              }
            }

            // AutoPlay Progress
            if (autoplay) {
              if (flkty.player.state !== "paused") {
                flkty.stopPlayer();
                flkty.playPlayer();
              }
            }

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector(
              ".slideshow__slide-video-bg"
            );
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector(
              ".slideshow__slide-video-bg"
            );
            if (video_container) {
              if (video_container.querySelector("iframe")) {
                if (
                  video_container.querySelector("iframe").classList.contains("lazyload")
                ) {
                  video_container
                    .querySelector("iframe")
                    .addEventListener(
                      "lazybeforeunveil",
                      slideshow.videoPlay(video_container)
                    );
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector("video")) {
                slideshow.videoPlay(video_container);
              }
            }

            // Custom Dots.
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll("li");
              dots.forEach((dot, i) => {
                dot.classList.remove("is-selected");
              });
              dots[this.selectedIndex].classList.add("is-selected");
            }
          },
        };
        if (
          slideshow.classList.contains("desktop-height-image") ||
          slideshow.classList.contains("mobile-height-image")
        ) {
          args.adaptiveHeight = true;
        }
      }

      // Testimonials
      if (slideshow.classList.contains("testimonials--carousel")) {
        args.on = {
          ready: function () {
            let flkty = this;

            // Custom Dots.
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll("li");
              dots.forEach((dot, i) => {
                dot.addEventListener("click", (e) => {
                  flkty.select(i);
                });
              });

              dots[this.selectedIndex].classList.add("is-selected");
            }
            // AutoPlay Progress
            if (autoplay && autoplay_progress) {
              slideshow.setupAutoplayProgress(slideshow, autoplay_progress);
            }
          },
          change: function (index) {
            // Custom Dots.
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll("li");
              dots.forEach((dot, i) => {
                dot.classList.remove("is-selected");
              });
              dots[this.selectedIndex].classList.add("is-selected");
            }

            if (autoplay && autoplay_progress) {
              slideshow.autoPlayProgressTL.progress(0);

              if (flkty.player.state !== "paused") {
                slideshow.autoPlayProgressTL.play();
              }
            }
          },
        };
      }
      // Product Carousels
      if (
        slideshow.classList.contains("products") ||
        slideshow.classList.contains("product-recommendations--products")
      ) {
        args.wrapAround = false;
        args.on.ready = function () {
          let flickity = this;
          const arrows =
            slideshow._cachedArrows ||
            (slideshow._cachedArrows = slideshow.resolveArrowButtons());
          if (arrows.next.length) {
            flickity.on("resize", function () {
              slideshow.centerArrows(flickity);
            });

            slideshow.setArrowsState(flickity);
          }
          slideshow.centerArrows(flickity);
        };
      }
      if (progress_bar) {
        args.wrapAround = false;
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          progress_bar.style.width = progress * 100 + "%";
        };
      }

      const responsiveGallery =
        document.body.classList.contains("template-index") &&
        slideshow.classList.contains("gallery--carousel") &&
        !slideshow.classList.contains("gallery--carousel--v2") &&
        !slideshow.classList.contains("carousel-on-desktop") &&
        !!slideshow.querySelector(".gallery--item--heading");
      if (responsiveGallery) {
        args.watchCSS = true;
      }

      // Initiate
      const flkty = new Flickity(slideshow, args);

      selectedIndex = flkty.selectedIndex;

      slideshow.dataset.initiated = true;

      // Cache arrow references after Flickity init
      slideshow._cachedArrows = slideshow.resolveArrowButtons();

      requestAnimationFrame(() => {
        flkty.resize();
        slideshow.setArrowsState(flkty);
      });

      if (
        window.matchMedia("(min-width: 768px)").matches &&
        slideshow.classList.contains("gallery--carousel") &&
        !slideshow.classList.contains("gallery--carousel--v2") &&
        !slideshow.classList.contains("carousel-on-desktop") &&
        !responsiveGallery &&
        !!flkty
      ) {
        flkty.destroy();
        return;
      }

      // Arrows
      const {prev: cached_prev, next: cached_next} = slideshow._cachedArrows;
      const goPrev = () => (document.dir === "rtl" ? flkty.next() : flkty.previous());
      const goNext = () => (document.dir === "rtl" ? flkty.previous() : flkty.next());

      cached_prev.forEach((btn) => {
        btn.addEventListener("click", () => !btn.hasAttribute("disabled") && goPrev());
        btn.addEventListener("keyup", () => !btn.hasAttribute("disabled") && goPrev());
      });
      cached_next.forEach((btn) => {
        btn.addEventListener("click", () => !btn.hasAttribute("disabled") && goNext());
        btn.addEventListener("keyup", () => !btn.hasAttribute("disabled") && goNext());
      });
      // Theme editor
      if (Shopify.designMode) {
        slideshow.addEventListener("shopify:block:select", (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

      this.addEventListener("change", this.reInit.bind(this));
    }
    reInit() {
      this.reloadCells();
    }

    setupAutoplayProgress(slideshow, autoplay_progress) {
      slideshow.autoPlayProgressTL = gsap.timeline({
        inherit: false,
      });
      slideshow.autoPlayProgressTL.fromTo(
        autoplay_progress,
        {
          scaleX: 0,
        },
        {
          duration: parseInt(slideshow.dataset.autoplay, 10) / 1000,
          scaleX: 1,
          ease: "linear",
        }
      );
      slideshow.addEventListener("mouseenter", function () {
        slideshow.autoPlayProgressTL.pause().progress(0);
      });
      slideshow.addEventListener("mouseleave", function () {
        slideshow.autoPlayProgressTL.play();
      });
    }

    videoPause(video_container) {
      setTimeout(() => {
        video_container.querySelector("video").pause();
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        video_container.querySelector("video").play();
      }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        let splittext = new SplitText(
          slideshow.querySelectorAll(".slideshow__slide-heading, p:not(.subheading)"),
          {
            type: "lines",
            linesClass: "line-child",
          }
        );
        let mask = new SplitText(
          slideshow.querySelectorAll(".slideshow__slide-heading, p:not(.subheading)"),
          {
            type: "lines",
            linesClass: "line-parent",
          }
        );

        slideshow.querySelectorAll(".slideshow__slide").forEach((item, i) => {
          let tl = gsap.timeline({
              paused: true,
            }),
            button_offset = 0;

          animations[i] = tl;

          if (slideshow.dataset.transition == "swipe") {
            tl.to(
              item,
              {
                duration: 0.7,
                clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)",
              },
              "start"
            );
          }

          if (slideshow.dataset.transition == "zoom") {
            tl.to(
              item.querySelectorAll(".slideshow__slide-bg, .slideshow__slide-video-bg"),
              {
                duration: 1.5,
                scale: 1,
              },
              "start"
            );
          }

          if (item.querySelector(".subheading")) {
            tl.fromTo(
              item.querySelector(".subheading"),
              {
                opacity: 0,
              },
              {
                duration: 0.5,
                opacity: 1,
              },
              0
            );

            button_offset += 0.5;
          }
          if (item.querySelector(".slideshow__slide-heading")) {
            let h1_duration =
              1 +
              (item.querySelectorAll(".slideshow__slide-heading .line-child").length -
                1) *
                0.1;
            tl.set(
              item.querySelectorAll(".slideshow__slide-heading"),
              {
                opacity: 1,
              },
              0
            ).from(
              item.querySelectorAll(".slideshow__slide-heading .line-child"),
              {
                duration: h1_duration,
                yPercent: 120,
                stagger: 0.1,
              },
              0
            );
            button_offset += h1_duration;
          }
          if (item.querySelector("p.split-text")) {
            let p_duration =
              1 + (item.querySelectorAll("p.split-text .line-child").length - 1) * 0.05;
            tl.set(
              item.querySelectorAll("p.split-text"),
              {
                opacity: 1,
              },
              0
            ).from(
              item.querySelectorAll("p:not(.subheading) .line-child"),
              {
                duration: p_duration,
                yPercent: "120",
                stagger: 0.1,
              },
              0
            );
            button_offset += p_duration;
          }
          if (item.querySelectorAll(".button, .text-button")) {
            tl.fromTo(
              item.querySelectorAll(".button, .text-button"),
              {
                autoAlpha: 0,
              },
              {
                duration: 0.5,
                stagger: 0.1,
                autoAlpha: 1,
              },
              button_offset * 0.2
            );
          }
          item.dataset.timeline = tl;
        });

        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, slideshow, animations) {
      let flkty = Flickity.data(slideshow);
      document.fonts.ready.then(function () {
        animations[i].restart();
      });
    }
    animateReverse(i, slideshow, animations) {
      animations[i].reverse();
    }
    resolveArrowButtons() {
      const containers = [
        this,
        this.previousElementSibling,
        this.parentElement,
        this.closest("product-recommendations"),
      ].filter(Boolean);
      const prevSet = new Set();
      const nextSet = new Set();

      for (const c of containers) {
        c.querySelectorAll(".flickity-prev").forEach((el) => prevSet.add(el));
        c.querySelectorAll(".flickity-next").forEach((el) => nextSet.add(el));
      }

      return {prev: [...prevSet], next: [...nextSet]};
    }
    setArrowsState(flickityInstance) {
      const arrows =
        this._cachedArrows || (this._cachedArrows = this.resolveArrowButtons());

      if (!arrows.prev.length && !arrows.next.length) {
        return;
      }

      const flk = flickityInstance || Flickity.data(this);
      let isAtStart = true;
      let isAtEnd = true;

      if (flk && flk.slides && flk.slides.length) {
        const cur = flk.selectedSlide
          ? flk.selectedSlide.target
          : flk.slides[flk.selectedIndex].target;
        const first = flk.slides[0].target;
        const last = flk.slides[flk.slides.length - 1].target;
        isAtStart = cur <= first + 0.5;
        isAtEnd = cur >= last - 0.5;
      }

      for (const btn of arrows.prev) {
        if (isAtStart) btn.setAttribute("disabled", "true");
        else btn.removeAttribute("disabled");
      }
      for (const btn of arrows.next) {
        if (isAtEnd) btn.setAttribute("disabled", "true");
        else btn.removeAttribute("disabled");
      }
    }
    centerArrows(flickity) {
      const image = flickity.cells
        .map((cell) => cell.element.querySelector(".product-featured-image"))
        .find(Boolean);
      if (!image) return;

      const imageRect = image.getBoundingClientRect();
      this.style.setProperty(
        "--carousel-arrow-top",
        `${imageRect.top - this.getBoundingClientRect().top + imageRect.height / 2}px`
      );
    }
  }
  customElements.define("slide-show", SlideShow);
}
